import { render } from "./doubleWrite.vue?vue&type=template&id=4d529cba&ts=true"
import script from "./doubleWrite.vue?vue&type=script&lang=ts"
export * from "./doubleWrite.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__